module.exports = __webpack_public_path__ + "img/icon_kehu_13.0cc566d7.png";